var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiscrepancies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29247 1.38698C4.12091 1.25919 3.87693 1.27339 3.72146 1.42958L1.34276 3.8193L1.30051 3.86847C1.17383 4.04003 1.18851 4.28305 1.34419 4.43802L1.39336 4.48026C1.56492 4.60695 1.80794 4.59227 1.96291 4.43659L3.59397 2.79765V9.68225L3.59796 9.74161C3.62693 9.95516 3.80998 10.1197 4.03147 10.1197C4.2731 10.1197 4.46897 9.92387 4.46897 9.68225V2.79773L6.10017 4.43659L6.14914 4.47906C6.32012 4.60654 6.5632 4.59298 6.71888 4.43802C6.89013 4.26756 6.89077 3.99055 6.72031 3.8193L4.34161 1.42958L4.33857 1.42694C4.32522 1.41379 4.31103 1.40148 4.29609 1.39011L4.29247 1.38698ZM10.2566 3.26209C10.2276 3.04854 10.0446 2.88395 9.82306 2.88395C9.58144 2.88395 9.38556 3.07983 9.38556 3.32145V10.2058L7.75437 8.56711L7.7054 8.52464C7.53442 8.39716 7.29133 8.41072 7.13565 8.56568C6.9644 8.73614 6.96376 9.01315 7.13422 9.1844L9.51293 11.5741L9.51596 11.5768C9.52931 11.5899 9.5435 11.6022 9.55844 11.6136L9.56206 11.6167C9.73362 11.7445 9.9776 11.7303 10.1331 11.5741L12.5118 9.1844L12.554 9.13523C12.6807 8.96367 12.666 8.72065 12.5103 8.56568C12.3391 8.39523 12.0621 8.39586 11.8916 8.56711L10.2606 10.2052V3.32145L10.2566 3.26209Z",
    fill: "#082A51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscrepancies);
export default __webpack_public_path__ + "static/media/icon-discrepancies.4e1652cdedd1de4c478624ee9f7b022e.svg";
export { ForwardRef as ReactComponent };